import {
  AddConsultantEventLogInterestMutationVariables,
  GetConsultantProfileNew,
  useAddConsultantEventLogInterestMutation
} from "@bonliva-crm/graphql";
import { HookProps } from "../utils/hook-props";

export function useAddConsultantEventLogInterest(props: HookProps) {
  const [addConsultantEventLogInterestMutation] =
    useAddConsultantEventLogInterestMutation({
      onError: (error) => {
        console.error(error);
        props.onError && props.onError(error);
      },
      onCompleted: (res) => {
        props.onCompleted && props.onCompleted(res.addConsultantInterestEvent);
      }
    });

  const addConsultantEventLogInterest = (
    args: AddConsultantEventLogInterestMutationVariables
  ) => {
    props.onBeforeCall && props.onBeforeCall();
    addConsultantEventLogInterestMutation({
      variables: args,
      refetchQueries: [GetConsultantProfileNew.OperationName]
    });
  };

  return { addConsultantEventLogInterest };
}
